<template>
    <div class="select-province">
        <v-cascader
            v-model="curSelect"
            :options="province"
            @change="change"
        >
            <template slot="header" slot-scope="props">
                <span>{{ curSelect.length > 0 ?
                    props.item.reduce(
                        (pre, cur) => pre + (pre ? '/' : '') + cur.text,
                        ''
                    ) || '请选择':
                    '请选择' }}
                </span>
            </template>
    </v-cascader>
    </div>
</template>

<script>
import { province } from '../utils/province';
export default {
    props: {
        eAddress: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            curSelect: [],
            province,
        };
    },
    created() {
        if (this.eAddress && this.eAddress.city && this.eAddress.province) {
            this.curSelect = [this.eAddress.province, this.eAddress.city];
        }
    },
    methods: {
        change() {
            this.$emit('change', {
                province: this.curSelect[0],
                city: this.curSelect[1],
            });
        },
    },
};
</script>

<style lang="less" scoped>
/deep/ .v-cascader {
    width: 100%;
}
</style>
